import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const SuperAdminContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function SuperAdminProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('sa_token'));
  const [email, setEmail] = useState(() => localStorage.getItem('sa_email'));

  const login = async (emailInput, password) => {
    const res = await fetch(`${API_URL}/api/superadmin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: emailInput, password })
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.detail || 'Login failed');
    }
    const data = await res.json();
    localStorage.setItem('sa_token', data.token);
    localStorage.setItem('sa_email', data.email);
    setToken(data.token);
    setEmail(data.email);
    return data;
  };

  const logout = useCallback(() => {
    localStorage.removeItem('sa_token');
    localStorage.removeItem('sa_email');
    setToken(null);
    setEmail(null);
  }, []);

  const apiFetch = useCallback(async (path, options = {}) => {
    const res = await fetch(`${API_URL}/api/superadmin${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(options.headers || {})
      }
    });
    if (res.status === 401) {
      logout();
      throw new Error('Session expired');
    }
    return res;
  }, [token, logout]);

  useEffect(() => {
    if (token) {
      apiFetch('/verify').then(r => {
        if (!r.ok) logout();
      }).catch(() => logout());
    }
  }, [token, apiFetch, logout]);

  return (
    <SuperAdminContext.Provider value={{ token, email, login, logout, apiFetch, isAuthenticated: !!token }}>
      {children}
    </SuperAdminContext.Provider>
  );
}

export const useSuperAdmin = () => useContext(SuperAdminContext);
